import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Warehouse } from 'lucide-react';
import { CustomSelect } from './CustomSelect';
import { warehousesOf } from '../data/store';
import { useSharedStore } from '../hooks/useSharedStore';

// Shared warehouse picker for the org-admin Warehouse section. Defaults to
// "All warehouses" (value 'all'); narrowing to a single warehouse passes its id.
export const WarehouseScopeBar = ({ org, value, onChange, accent }) => {
  const { version: dataVersion } = useSharedStore();
  const options = useMemo(() => ([
    { value: 'all', label: 'All warehouses' },
    ...warehousesOf(org.id).map((w) => ({ value: w.id, label: w.name })),
  ]), [org.id, dataVersion]);

  return (
    <section className="bg-white border border-[var(--theme-tertiary)] rounded-xl px-5 py-3 flex items-center gap-3">
      <span
        className="w-9 h-9 rounded-xl flex items-center justify-center text-white shrink-0"
        style={{ background: accent }}
        aria-hidden="true"
      >
        <Warehouse size={16} />
      </span>
      <div className="min-w-0">
        <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500">Warehouse</p>
        <p className="text-[11px] font-medium text-slate-400 leading-tight">Showing {value === 'all' ? 'all warehouses' : '1 warehouse'}</p>
      </div>
      <div className="ml-auto w-56 max-w-[60%]">
        <CustomSelect
          value={value}
          onChange={onChange}
          options={options}
          className="w-full bg-[var(--theme-secondary)] border-[var(--theme-tertiary)] text-xs font-semibold normal-case tracking-normal py-2 px-3"
        />
      </div>
    </section>
  );
};

WarehouseScopeBar.propTypes = {
  org: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  accent: PropTypes.string.isRequired,
};
